<template>
  <div>
    <div class="live-bg com-news">
      <div class="txtMarquee-left">
        <div class="block">
          <div class="iconfont icon-tongzhi2"></div>
          <p>
            <font style="vertical-align: inherit"><font style="vertical-align: inherit">{{$t('index.announcement')}}</font></font>
          </p>
          <div id="memberLatestAnnouncement" @click="$parent.goNav('/message?type=1')">
            <marquee scrollamount="8" scrolldelay="100" direction="left" onclick="hotNewsHistory()" onmouseover="this.stop();" onmouseout="this.start();"
              ><font style="vertical-align: inherit"><font style="vertical-align: inherit">{{$t('index.official')}} </font></font></marquee
            >
          </div>
        </div>
      </div>
    </div>
    <div class="elec-container" id="elec-container_">
      <div class="elec-game-container" id="elec-game-container_">
        <div class="elec-game-list" id="elec-game-list_">
          <dl id="elec-game-list-box_">
            <dd  v-for="(item, index) in gameList" :key="index" v-if="item.app_state == 1">
              <div class="elec-game-box">
                <div class="elec-game-subscript"></div>
                <div class="elec-game-img-box">
                  <img :src="`/static/image/realbet/${item.platform_name}.jpg`"  alt="" class="elec-game-img" />
                  <h3 class="platform-name">
                    <font style="vertical-align: inherit"><font style="vertical-align: inherit">{{ item.name }}</font></font>
                  </h3>
                </div>
                <a href="javascript:;" @click="$parent.openGamePage(item.platform_name, item.game_code, '')"  class="elec-game-hover"
                  ><span class="game-begin"
                    ><font style="vertical-align: inherit"><font style="vertical-align: inherit">{{$t('index.playgames')}} </font></font></span
                  ></a
                >
              </div>
            </dd>
          </dl>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
export default {
  name: 'index',
  data() {
    return {
      gameList: [],

      imgList: {
        bbin: { img: '/static/image/zrbbin.png', hover: '/static/image/bbin_hover.png', title: '/static/image/img_bbinzr_title.png' },
        bg: { img: '/static/image/zrbg.jpg', hover: '/static/image/bg_hover.png', title: '/static/image/img_bgzr_title.png' },
        ag: { img: '/static/image/zrag.jpg', hover: '/static/image/ag_hover.png', title: '/static/image/img_ag_title.png' },
        wm: { img: '/static/image/zrwm.jpg', hover: '/static/image/wm_hover.png', title: '/static/image/img_wm_title.png' },
        qg: { img: '/static/image/zrog.jpg', hover: '/static/image/og_hover.png', title: '/static/image/img_og_title.png' },
        dg: { img: '/static/image/zrdg.jpg', hover: '/static/image/dg_hover.png', title: '/static/image/img_dg_title.png' },
        allbet: { img: '/static/image/zrallbet.jpg', hover: '/static/image/allbet_hover.png', title: '/static/image/img_allbet_title.png' },
        obgzr: { img: '/static/image/zrae.jpg', hover: '/static/image/ob-hover.png', title: '/static/image/img_obzr_title.png' },
      
      
      },
    };
  },
  created() {
    let that = this;
    that.getGameList();
  },
  methods: {
    getGameList() {
      let that = this;
      that.$parent.showLoading();

      that.$apiFun.get('/api/game/list', { category: 'realbet' }).then(res => {
        if (res.code == 200) {
          that.gameList = res.data;
          that.$parent.hideLoading();
        }
      });
    },
  },
  mounted() {
    let that = this;
  },
  updated() {
    let that = this;
  },
  beforeDestroy() {},
};
</script>
<style lang="scss" scoped>
@import '../../../static/css/realbet-game-com.css';

.index-page {
    background-image: url(/static/image/bg.jpg)!important;
}


</style>



// WEBPACK FOOTER //
// src/components/mode/realbet.vue